<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Разрешения на охоту') }}</h1>
    <div class="my-organization">
      <div class="create-quota-pg view bgw-pdg-20">
        <p class="status text-center">
          {{ $t('Статус') }}: {{ licenseApplication.statusName }}
        </p>
        <h4 class="text-center">{{ $t('Заявка на охоту на добычу диких животных') }} {{ licenseApplication.ooptName }}</h4>
        <div class="form-group">
          <div class="quota-fields justify-content-between">
            <div class="quota-field field-column">
              <p>{{ $t('Дата') }}: {{ licenseApplication.date }} № {{ licenseApplication.number }}</p>
              <p v-if="licenseApplication.incomingDate">
                {{ $t('Входящие') }}: {{ licenseApplication.incomingDate }} № {{ licenseApplication.incomingNumber }}
              </p>
            </div>
            <div class="quota-field">
              <p>
                <strong>{{ $t('Тип') }}: {{ licenseApplication.typeName }}</strong>
              </p>
            </div>
            <div class="quota-field">
              <p>{{ $t('Отправитель') }}: {{ licenseApplication.userFio }}</p>
            </div>
          </div>
        </div>
        <FaunaLicenses :faunaLicenses="faunaLicenses" :editable="false" :foreignCitizenTypeFlag="licenseApplication.type === foreignCitizenType"/>
        <div class="quota-bottom">
          <PayInfo :licenseApplication="licenseApplication" />
        </div>
        <div class="quota-bottom">
          <Documents v-bind:documents.sync="documents" :editable="false" :applicationId="licenseApplication.id"/>
        </div>
        <template v-if="isSpecialist === false || (isSpecialist === true && licenseApplication.statusId === processedStatus)">
          <FaunaLicenseApplicationBsos v-bind:bsos.sync="faunaLicenseApplicationBsos" :editable="false" :issueDate="licenseApplication.issueDate"/>
        </template>
        <div class="quota-bottom">
          <LastHistoryInfo :history="history"/>
          <template v-if="isSpecialist === false || (isSpecialist === true && (licenseApplication.statusId === deniedStatus || licenseApplication.statusId === processedStatus))">
            <div v-if="licenseApplication.file">
              <template
                v-if="checkFileExist(licenseApplication.fileExtension)"
              >
                <p>
                  <a
                    @click="previewDocumentDialog(licenseApplication.id + '_answer', true)"
                  >{{ $t('Файл документа') }}</a>
                </p>
                <v-dialog
                  v-model="previewDocsModal[licenseApplication.id + '_answer']"
                  max-width="1200"
                >
                  <v-card class="modal">
                    <div class="modal-head">
                      {{ $t('Файл документа') }}
                      <v-btn
                        color="modal-close"
                        @click="previewDocumentDialog(licenseApplication.id + '_answer', false)"
                      >
                        <img src="@/assets/img/close-icon.png" alt="icon">
                      </v-btn>
                    </div>
                    <div class="modal-body">
                      <VueDocPreview
                        :value="backUrl + licenseApplication.file"
                        type="office"
                      />
                    </div>
                  </v-card>
                </v-dialog>
              </template>
              <template v-else>
                <a
                  v-if="licenseApplication.file"
                  :href="backUrl + licenseApplication.file"
                  target="_blank"
                >{{ $t('Файл документа') }}</a>
              </template>
            </div>
            <template v-if="licenseApplication.processingDate">
              <p>{{ $t('Дата обработки') }}: {{ licenseApplication.processingDate }}</p>
            </template>
            <template v-if="licenseApplication.documentsDetails">
              <p>{{ $t('Реквизиты документа') }}: {{ licenseApplication.documentsDetails }}</p>
            </template>
          </template>
        </div>
        <div class="form-action">
          <template v-for="actionPermission in actionPermissions">
            <v-btn
              :key="actionPermission.id"
              @click="action(actionPermission)"
              :class="actionPermission.class"
              class="btn btn-default"
            >
              {{ actionPermission.name }}
            </v-btn>
            <template
              v-if="(actionPermission.type == 'license_status' || actionPermission.type == 'license_allocate') && actionPermission.comment === true">
              <v-dialog
                v-model="commentDialog[actionPermission.id]"
                scrollable
                max-width="600px"
                :key="'action_'+actionPermission.id"
              >
                <v-card class="modal observer-modal">
                  <div class="modal-head">
                    {{ $t('Добавление комментария') }}
                    <v-btn color="modal-close" @click="changeCommentDialog(actionPermission.id, false)">
                      <img src="@/assets/img/close-icon.png" alt="icon">
                    </v-btn>
                  </div>
                  <div class="modal-body">
                    <v-row>
                      <v-col cols="4" md="4" class="input-label">
                        <v-label>
                          {{ $t('Комментарий') }}:
                        </v-label>
                      </v-col>
                      <v-col class="input-field">
                        <v-textarea
                          v-model="comment"
                          outlined
                          dense
                          clearable
                        />
                      </v-col>
                    </v-row>
                    <div class="form-action">
                      <button
                        class="btn btn-default blue"
                        type="button"
                        @click="changeStatus({ id: actionPermission.id, type: actionPermission.type, comment: comment }),  changeCommentDialog(actionPermission.id, false)"
                      >
                        {{ $t('Добавить') }}
                      </button>
                      <button
                        class="btn btn-default gray"
                        type="button"
                        @click="changeCommentDialog(actionPermission.id, false)"
                      >
                        {{ $t('Отмена') }}
                      </button>
                    </div>
                  </div>
                </v-card>
              </v-dialog>
            </template>
          </template>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import License from '@/model/license'
import Documents from '@/components/license/Documents'
import FaunaLicenses from '@/components/license/FaunaLicenses'
import PayInfo from '@/components/license/PayInfo'
import LastHistoryInfo from '@/components/license/LastHistoryInfo'
import FaunaLicenseApplicationBsos from '@/components/license/FaunaLicenseApplicationBsos'
import VueDocPreview from 'vue-doc-preview'

export default {
  components: {
    Documents,
    FaunaLicenses,
    FaunaLicenseApplicationBsos,
    PayInfo,
    LastHistoryInfo,
    VueDocPreview
  },
  data: () => ({
    breadcrumbs: [],
    licenseApplication: {},
    backUrl: process.env.VUE_APP_BACK_URL,
    commentDialog: [],
    comment: null,
    actionPermissions: {},
    isSpecialist: false,
    deniedStatus: null,
    processedStatus: null,
    foreignCitizenType: null,
    history: {},
    faunaLicenses: [],
    documents: [],
    previewDocsModal: [],
    faunaLicenseApplicationBsos: []
  }),
  mounted () {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    // получаем данные
    fetchData () {
      this.setLoading(true)
      License.showApplication(this.$route.params.id).then((response) => {
        this.licenseApplication = response.data.applicationPermit
        this.history = response.data.lastHistory
        this.isSpecialist = response.data.isSpecialist
        this.deniedStatus = response.data.deniedStatus
        this.processedStatus = response.data.processedStatus
        this.foreignCitizenType = response.data.foreignCitizenType
        this.faunaLicenses = response.data.faunaLicenses
        this.documents = response.data.documents
        this.generateBreadcrumbs()
        this.scrollToTop()
        this.getActions(this.licenseApplication.statusId)
        this.getFaunaLicenseApplicationBsos()
      }).catch((error) => {
        this.$router.push({
          name: 'error',
          params: {
            status: error.response.status
          }
        })
      })
      this.setLoading(false)
    },
    // Выданные БСО
    getFaunaLicenseApplicationBsos () {
      License.getFaunaLicenseApplicationsWithBsos(this.$route.params.id).then((response) => {
        this.faunaLicenseApplicationBsos = response.data.faunaLicenseApplications
      }).catch((error) => {
        this.$router.push({
          name: 'error',
          params: {
            status: error.response.status
          }
        })
      })
    },
    // список действий
    getActions (statusId) {
      License.getApplicationActions(statusId).then((response) => {
        this.actionPermissions = response.data
      })
    },
    // действия
    action (actionPermission) {
      if (actionPermission.type === 'license_status' || actionPermission.type === 'license_allocate') {
        if (actionPermission.comment === true) {
          this.changeCommentDialog(actionPermission.id, true)
        } else {
          this.changeStatus({
            id: actionPermission.id,
            type: actionPermission.type
          })
        }
      } else if (actionPermission.type === 'license_edit') {
        this.$router.push({
          name: 'license-application-edit',
          params: {
            id: this.$route.params.id
          }
        })
      } else if (actionPermission.type === 'license_allocate_edit') {
        this.$router.push({
          name: 'license-issue-bso',
          params: {
            id: this.$route.params.id
          }
        })
      } else if (actionPermission.type === 'license_refuse') {
        this.$router.push({
          name: 'license-application-refuse',
          params: {
            id: this.$route.params.id
          }
        })
      } else if (actionPermission.type === 'license_cancel') {
        this.onCancel()
      }
    },
    changeStatus (data) {
      License.changeStatusApplication(this.licenseApplication.id, data)
        .then((response) => {
          this.licenseApplication.statusId = response.data.statusId
          this.licenseApplication.statusName = response.data.statusName
          this.history = response.data.lastHistory
          this.getActions(this.licenseApplication.statusId)
          if (data.type === 'license_allocate') {
            this.$router.push({
              name: 'license-issue-bso',
              params: {
                id: this.$route.params.id
              }
            })
          }
        })
        .catch((error) => {
          this.$noty.warning(this.$i18n.t('Ошибка'), {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
        })
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Заявки на охоту'),
          disabled: false,
          href: this.isSpecialist === true ? '/society-license-application-list/' + this.licenseApplication.ooptId : '/license-application-list/'
        },
        {
          text: this.$i18n.t('Просмотр заявки на разрешение'),
          disabled: true
        }
      ]
    },
    // предпросмотр файлов
    previewDocumentDialog (id, flag) {
      this.$set(this.previewDocsModal, id, flag)
    },
    // изменение статуса модального окна для комментариев
    changeCommentDialog (id, flag) {
      this.comment = null
      this.$set(this.commentDialog, id, flag)
    },
    // отмена
    onCancel () {
      this.isSpecialist === true
        ? this.$router.push({
          name: 'society-license-application-list',
          params: {
            id: this.licenseApplication.ooptId
          }
        })
        : this.$router.push({
          name: 'license-application-list'
        })
    },
    checkFileExist (ext) {
      const fileExtensions = ['doc', 'docx', 'xls', 'xlsx']
      const exist = fileExtensions.some(function (field) {
        return field === ext
      })
      return exist
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.quota-bottom {
  .table-overflow {
    margin-bottom: 30px;
  }
}

.form-action {
  margin-top: 40px;
}
</style>
